import React from 'react'
import { Link } from 'react-router-dom'

function Footer() {
  return (
    <div>
       {/* <!-- Footer Section Start --> */}
        <footer class="footer-section section-bg-2 fix">
            <div class="footer-shape">
                <img src="assets/img/logo/logo.png" alt="img" style={{width:"50px" ,height:"50px"}}/>
            </div>
            <div class="container">
                <div class="footer-wrapper">
                    <div class="row g-4">
                        <div class="col-xl-6 wow fadeInUp" data-wow-delay=".3s">
                            <div class="footer-left-items">
                                <a href="index-2.html" class="footer-logo">
                                   <img src="assets/img/logo/logo.png" alt="img" style={{width:"250px" ,height:"150px"}}/>
                                </a>
                                <p class="footer-text">
                                    Don’t worry—we’re here to help! Contact our support team or set custom alerts to find homes that perfectly match your needs and budget.
                                </p>
                                <ul class="footer-contact-list">
                                    <li>
                                        <i class="fa-solid fa-phone-xmark"></i>
                                        <a href="9799418563.html">919799418563</a><br></br>
                                        <i class="fa-solid fa-phone-xmark"></i>
                                           <a href="9799418563.html">+919828551389</a>
                                    </li>
                                    <li>
                                        <i class="fa-solid fa-envelopes"></i>
                                        <a href="mailto: rsgurjar304030@gmail.com"> rsgurjar304030@gmail.com</a><br></br>
                                        <i class="fa-solid fa-envelopes"></i>   
                                     <a href="mailto:example@gmail.com">jagdish281278@gmail.com</a>
                                    </li>
                                    <li>
                                        <i class="fa-solid fa-location-dot"></i>
                                        CHOMU TO CHANDWAJI, STATE HIGHWAY, MORIJA TEH: CHOMU, DISTT.-JAIPUR (RAJ.)
                                    </li>
                                </ul>
                                <ul class="footer-text-list">
                                   <li>
                                                <Link to={"/contact"}>Contact Us</Link>
                                            </li>
                                      <li><Link to={"/about"}>About Us</Link></li>
                                    <li><Link to={"/blogdetail"}>Blog</Link></li>
                                    
                                </ul>
                            </div>
                        </div>
                        {/* <div class="col-xl-6 wow fadeInUp" data-wow-delay=".5s">
                            <div class="foorer-right-items">
                                <h3>Subcribe To Our Newsletter</h3>
                                <p>Subcribe To Our Newsletter Subcribe To Our Newsletter Subcribe To Our Newsletter</p>
                                <form action="#">
                                    <input type="text" name="email" id="email2" placeholder="Email address"/>
                                    <button class="theme-btn" type="submit">
                                        SUBSCRIBE 
                                    </button>
                                </form>
                                <div class="row justify-content-between">
                                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-6">
                                        <div class="footer-widget-items">
                                            <div class="widget-head">
                                                <h4>Working Hours</h4>
                                            </div>
                                            <ul class="list-area">
                                                <li>
                                                    <a href="service-details.html">
                                                        Strategy Services
                                                    </a>
                                                </li>
                                                 <li>
                                                    <a href="service-details.html">
                                                        Business Advice
                                                    </a>
                                                </li>
                                                 <li>
                                                    <a href="service-details.html">
                                                       Management
                                                    </a>
                                                </li>
                                                 <li>
                                                    <a href="service-details.html">
                                                        Financial Advice
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div> 
                                     <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-6">
                                        <div class="footer-widget-items">
                                            <div class="widget-head">
                                                <h4>Contact Us</h4>
                                            </div>
                                            <ul class="list-area">
                                                <li>
                                                    <a href="contact.html">
                                                       Terms of Use
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="contact.html">
                                                       Privacy Policy
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="service.html">
                                                       Our Services
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="contact.html">
                                                      Contact Support
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div> 
                                     <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6">
                                        <div class="footer-widget-items">
                                            <div class="widget-head">
                                                <h4>Quick links</h4>
                                            </div>
                                            <ul class="list-area">
                                                <li>
                                                    <a href="about.html">
                                                      About Us
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="team.html">
                                                       Our Team
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="propertie-list.html">
                                                       Add Listing
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="propertie.html">
                                                      Property
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
            <div class="footer-bottom">
                <div class="container">
                    <p class="wow fadeInUp" data-wow-delay=".3sgit">© 2025 Powered By <b>Shree JRB</b> . All Rights Reserved.</p>
                </div>
            </div>
        </footer>
    </div>
  )
}

export default Footer